export default __webpack_public_path__ + "static/media/gillete.a01a630a.svg";